<template>
  <router-link :to="{name: 'new-order'}" class="btn-primary bp-header w-inline-block">
    <div class="icon-12px icon-12px-btn">
      <PlusIcon />
    </div>
    <div>
      <span class="m-hidden">Новый заказ</span>
    </div>
  </router-link>
</template>

<script>
  import PlusIcon from '@/icons/plus.svg';

  export default {
    name: 'NewOrderLink',
    components: {PlusIcon},
  };
</script>
